export default class Therapy {
  constructor(
    public readonly id: number,
    public readonly name: string,
    public readonly type: string,
    public readonly duration: number,
    public readonly durationUnit: string,
  ) {}
}
